module.exports = __webpack_public_path__ + "static/media/ImpactStoryLogoWorldBank.77e28245.png";